<template>
  <nav v-if="total" class="list-pagination" aria-label="列表分页">
    <span class="list-pagination-total">共 {{ total }} 条</span>
    <button type="button" class="list-pagination-button" :disabled="page <= 1" aria-label="上一页" @click="change(page - 1)">上一页</button>
    <button
      v-for="item in pageItems"
      :key="item.key"
      type="button"
      class="list-pagination-button list-pagination-page"
      :class="{ active: item.value === page, ellipsis: item.ellipsis }"
      :disabled="item.ellipsis"
      :aria-current="item.value === page ? 'page' : undefined"
      @click="change(item.value)"
    >{{ item.label }}</button>
    <button type="button" class="list-pagination-button" :disabled="page >= totalPages" aria-label="下一页" @click="change(page + 1)">下一页</button>
    <span class="list-pagination-info">{{ page }} / {{ totalPages }} 页</span>
  </nav>
</template>

<script>
export default {
  name: 'ListPagination',
  props: {
    page: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    total: { type: Number, default: 0 }
  },
  computed: {
    totalPages () { return Math.max(1, Math.ceil(this.total / Math.max(1, this.pageSize))) },
    pageItems () {
      const total = this.totalPages
      const current = Math.min(Math.max(this.page, 1), total)
      if (total <= 7) return Array.from({ length: total }, (_, index) => ({ key: 'page-' + (index + 1), value: index + 1, label: index + 1 }))
      const values = [1]
      const start = Math.max(2, current - 1)
      const end = Math.min(total - 1, current + 1)
      if (start > 2) values.push('ellipsis-start')
      for (let value = start; value <= end; value += 1) values.push(value)
      if (end < total - 1) values.push('ellipsis-end')
      values.push(total)
      return values.map(value => value === 'ellipsis-start' || value === 'ellipsis-end'
        ? { key: value, label: '…', ellipsis: true }
        : { key: 'page-' + value, value, label: value })
    }
  },
  methods: {
    change (value) {
      const next = Math.min(Math.max(Number(value) || 1, 1), this.totalPages)
      if (next !== this.page) this.$emit('change', next)
    }
  }
}
</script>

